import ReactGA from "react-ga4";

// Replace with your actual GA4 Measurement ID
// const TRACKING_ID = process.env.REACT_APP_GA_MEASUREMENT_ID;
const TRACKING_ID = "G-MB8CQXVXZH";

export const initGA = () => {

ReactGA.initialize(TRACKING_ID);
};

export const trackPageView = (path, title) => {
  ReactGA.send({ hitType: "pageview", page: path, title: title });
};

export const trackEvent = (action, category, label, value) => {
  ReactGA.event({
    action,
    category,
    label,
    value,
  });
};

// Specific tracking functions for common actions
export const trackButtonClick = (buttonName, location) => {
  trackEvent("click", "button", `${buttonName}_${location}`);
};

export const trackFormSubmit = (formName, location) => {
  trackEvent("submit", "form", `${formName}_${location}`);
};

export const trackNavigation = (linkName, location) => {
  trackEvent("click", "navigation", `${linkName}_${location}`);
};

/** E-Store admin and public shop (GA4 category: estore) */
export const trackEstoreEvent = (action, label) => {
  trackEvent(action, "estore", label);
};